<script setup>
import { useRouter } from 'vue-router'
import { useSession } from './stores/session'

const session = useSession()
const router = useRouter()

async function logout() {
  await session.logout()
  router.push('/login')
}
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <header class="bg-white border-b border-slate-200">
      <nav class="max-w-4xl mx-auto px-4 h-14 flex items-center gap-4">
        <RouterLink to="/" class="font-semibold text-indigo-700"><i class="fa-solid fa-graduation-cap mr-2"></i>Подготовка</RouterLink>
        <div class="flex-1"></div>
        <RouterLink to="/program" class="text-sm text-slate-600 hover:text-slate-900" title="Программа"><i class="fa-solid fa-school sm:mr-1"></i><span class="hidden sm:inline">Программа</span></RouterLink>
        <RouterLink to="/memos" class="text-sm text-slate-600 hover:text-slate-900" title="Памятки"><i class="fa-solid fa-book-open sm:mr-1"></i><span class="hidden sm:inline">Памятки</span></RouterLink>
        <template v-if="session.signedIn">
          <RouterLink to="/me" class="text-sm text-slate-600 hover:text-slate-900" title="Кабинет"><i class="fa-solid fa-user sm:mr-1"></i><span class="hidden sm:inline">Кабинет</span></RouterLink>
          <button class="text-sm text-slate-500 hover:text-slate-900" title="Выйти" @click="logout"><i class="fa-solid fa-right-from-bracket sm:mr-1"></i><span class="hidden sm:inline">Выйти</span></button>
        </template>
      </nav>
    </header>
    <main class="flex-1 max-w-4xl w-full mx-auto px-4 py-6">
      <RouterView />
    </main>
  </div>
</template>
